<template>
    <div v-cloak class="modal" tabindex="-1" role="dialog" v-bind:class="isActive ? 'camera-popup' : ''" v-if='isActive'>
        <div class="camera-info">
            <label v-if="maxPhotos">{{storedPhotos.length}} фото из {{maxPhotos}}</label>
            <label v-else style="width: 150px;">{{storedPhotos.length}} фото</label>
        </div>
        <button type="button" class="camera-button" id="camera-fin-btn" @click="savePhotos">Готово</button>
        <div id="camera-black-area"></div>
        <video id="camera-area" autoplay playsinline></video>
        <canvas id="photo-canvas"></canvas>
        <div class="container" id="camera-btns">
            <div class="row">
                <div class="col">
                    <img :src="lastPhoto" class="last-photo"></img>
                </div>
                <div class="col">
                <button class="photocircle" @click="takePhoto"></button>
                </div>
                <div class="col">
                    <div class="file-input-wrapper">
                        <label for="file-camera-gallery" class="camera-gallery">
                            <img src="/images/photo.png" class="camera-media">
                        </label>
                        <input id="file-camera-gallery" @change="onPhotoAdd" type="file" accept="image/*" multiple />
                    </div>


                    
                </div>
            </div>
            </div>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
    name: 'popup-camera',
	props: ["value", "isActive", "maxPhotos"],
	data() {
		return {
			onlyOneCamera: false,
			errorInitCamera: false,
			storedPhotos: [],
			canvas: {},
			video: {},
			constraints: [],
			constraintID: 0,
			lastPhoto: "",
			activeStream: undefined,
		}
	},	
	methods: {
		closePopup: function () {
			this.storedPhotos = [],
			this.lastPhoto = ""
			if (this.activeStream) {
				this.activeStream.getTracks().forEach(function(track) {
					if (track.readyState == 'live') {
						track.stop();
					}
				});
			}
			this.$emit('closepopup')
		},
		initCamera: function(stream) {
			this.activeStream = stream
			this.canvas = document.getElementById("photo-canvas");
			this.video = document.getElementById('camera-area');
			const videoTracks = stream.getVideoTracks();
			console.log(`Using video device: ${videoTracks[0].label}`);
			window.stream = stream; // make variable available to browser console
			this.video.srcObject = stream;
		},
		switchCamera() {
			if (this.constraintID == 1) {
				this.constraintID = 0
			} else {
				this.constraintID = 1
			}
			let curConstr = this.constraints[this.constraintID]
			navigator.mediaDevices.getUserMedia(curConstr)
				.then(function(mediaStream) {
					comp.initCamera(mediaStream)
				  })
				  .catch(function(err) { 
					  comp.onlyOneCamera = true
					  comp.switchCamera()
				  })
		},
		onPhotoAdd(e) {
			var files = e.target.files;
			if(files){
				let photosToAdd = []
				let totalLen = this.storedPhotos.length + files.length
				if (totalLen > this.maxPhotos) {
					let canLeave = 4 - this.storedPhotos.length
					for (i = 0; i < canLeave; i++) {
						photosToAdd.push(files[i])
					}
				} else {
					photosToAdd = files
				}

				this.addPhotos(photosToAdd)
			}
		},
		addPhotos(files) {
			var files_count = files.length;
			let comp = this
			for (let i=0; i<files_count; i++){
				var reader = new FileReader();
				reader.onload = function(e){
					if (comp.maxPhotos == 1) {
						comp.storedPhotos = e.target.result
						comp.savePhotos()
					} else {
						comp.storedPhotos.push(e.target.result)
					}
					comp.lastPhoto = comp.storedPhotos[comp.storedPhotos.length-1]
					if (comp.storedPhotos.length == comp.maxPhotos) {
						comp.savePhotos()
					}
				}
				reader.readAsDataURL(files[i]);
			}
		},
		takePhoto() {
			this.canvas.width = this.video.videoWidth;
			this.canvas.height = this.video.videoHeight;
			this.canvas.getContext('2d').drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
			let imgData = this.canvas.toDataURL('image/png')
			if (imgData.length < 20) {
				return
			}
			if (this.maxPhotos == 1) {
				this.storedPhotos = imgData
				this.savePhotos()
			} else {
				this.storedPhotos.push(imgData)
			}
			this.lastPhoto = this.storedPhotos[this.storedPhotos.length-1]
			if (this.storedPhotos.length == this.maxPhotos) {
				this.savePhotos()
			}
			this.animatePhoto()
		},
		animatePhoto() {
			let blackArea = document.getElementById("camera-black-area")
			blackArea.style.display = "block"
			let video = this.video
			video.style.display = "none"
			setTimeout(
				function() {
					blackArea.style.display = "none"
					video.style.display = "block"
				}, 100);
			
		},
		savePhotos() {
			this.$emit('input', this.storedPhotos)
			this.closePopup()
		}
	},
	watch: {
		isActive() {
			if (!this.isActive) {
				return
			}
			if (this.maxPhotos == 1) {
				this.storedPhotos = []
				this.lastPhoto = ""
			} else {
				this.storedPhotos = this.value
				this.lastPhoto = this.value[this.value.length - 1]
			}
			
			$(window).on("orientationchange",function(){
				// alert("orientation")
				setTimeout(
					function() {
						document.getElementById("camera-btns").style.display = "block"
						let windowHeight = $(window).height();
						let videoH = windowHeight - 135
						document.getElementById('camera-area').style.height = videoH + "px"
						document.getElementById("camera-black-area").style.height = videoH + "px"
						console.log("The orientation has changed! Height: " + windowHeight);
						console.log("target h: " + videoH)
					}, 50);
				//buttons height 135px
				
			}).trigger('orientationchange');

			let comp = this
			if (navigator.mediaDevices === undefined) {
				navigator.mediaDevices = {};
			}

			if (navigator.mediaDevices.getUserMedia === undefined) {
				navigator.mediaDevices.getUserMedia = function(constraints) {

					var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

					if (!getUserMedia) {
						return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
					}

					return new Promise(function(resolve, reject) {
						getUserMedia.call(navigator, constraints, resolve, reject);
					});
				}
			}

			
			const constraintsEnv = window.constraints = {
				audio: false,
				video: { facingMode: { exact: "environment" } }
			  };

			const constraintsFace = window.constraints = {
				audio: false,
				video: { facingMode: "user" }
			  };

			this.constraints.push(constraintsEnv)
			this.constraints.push(constraintsFace)

			navigator.mediaDevices.getUserMedia(constraintsEnv)
			.then(function(mediaStream) {
				comp.initCamera(mediaStream)
			  })
			  .catch(function(err) { 
				comp.onlyOneCamera = true
				navigator.mediaDevices.getUserMedia(constraintsFace)
				.then(function(mediaStream) {
					comp.initCamera(mediaStream)
				  })
				  .catch(function(err) { 
					  comp.errorInitCamera = true
					  alert("Ошибка подключения к камере. Воспользуйтесь медиатекой (справа снизу) и стандартным интерфейсом камеры.")
					//   comp.closePopup()
					  console.log(err)
				  })

			  }); 
		}
	},
}
</script>

<style scoped>
.camera-button {
  background: #D02138;
  color: white;
  border-radius: 4px;
  border: none;
  font-size: 14px;
}

.camera-popup {
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    background: black;
}

.camera-popup #camera-area {
    height: 80%;
    width: 100%;
    display: block;
    margin: auto;
}

.photocircle {
    height: 60px;
    width: 60px;
    background-color: white;
    border-radius: 50%;
    display: block;
    margin: auto;
    margin-top: 10px;
}

.camera-media {
    float: left;
    margin-top:13px;
    margin-left: 25px;
    height: 55px;
}

.last-photo {
    float: right;
    margin-top:15px;
    margin-right: 25px;
    height: 50px;
}

.camera-info {
    margin-top: 12px;
    margin-left: 15px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 120%;
    text-align: left;
    color: #FFFFFF;

}

.camera-gallery {
    width: 115px;
    height: 80px;
    border: 1px dashed rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    border-radius: 4px;
    display: block;
}

#photo-canvas {
    position: absolute;
    top: 10000px;
    left: 10000px;
}

#camera-fin-btn {
    float: right;
    margin-top: -33px;
    margin-right: 5px;
    width: 100px;
    height: 28px;
    padding: 0px;
}

#camera-black-area {
    height: 80%;
    width: 100%;
    display: none;
    margin: auto;
}

#camera-btns {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/CameraPopup.vue